import { useEffect, useMemo, useState } from "react";
import styles from "./guides.module.css";
import { useTranslation } from "react-i18next";
import { Button, Select } from "../../uikit";
import { downloadConfig } from "../../utils/DownloadConfig";
import { useNavigate } from "react-router";
import {
  getCountryEmoji,
  sortServersForDisplay,
  translateCity,
} from "../../utils/serverDisplay";
import { getToken } from "../../utils/tokenStorage";

const GuideOvpnData = ({ subscription, servers, label }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedHostname, setSelectedHostname] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const hasLabel = (label || "").trim() !== "";

  const getServerHostname = (server) => server.hostname || server.domain || server.name || "";
  const getServerRequestName = (server) => server.request_name || server.name || "";

  const sortedServers = useMemo(() => {
    return sortServersForDisplay(servers, {
      preferredServerName: subscription?.last_exit_server_name,
    });
  }, [servers, subscription?.last_exit_server_name]);

  useEffect(() => {
    if (sortedServers.length) {
      setSelectedHostname((current) => {
        if (
          current &&
          sortedServers.some((server) => getServerHostname(server) === current)
        ) {
          return current;
        }
        return getServerHostname(sortedServers[0]);
      });
    }
  }, [sortedServers]);

  const setSelectedHostnameHandler = (event) => {
    setSelectedHostname(event.target.value);
  };

  const formatServerLabel = (server) => {
    const country = getCountryEmoji(server.country_code);
    const city = translateCity(
      server.city || server.location || "",
      server.city_ru,
      i18n.resolvedLanguage,
    );
    const name = server.name || server.hostname || "";
    const location = [country, city].filter(Boolean).join(" ");
    return [location, name].filter(Boolean).join(" - ");
  };

  const hasMultipleServers = sortedServers.length > 1;
  const selectedServer =
    sortedServers.find(
      (server) => getServerHostname(server) === selectedHostname
    ) || sortedServers[0];

  const download = async () => {
    try {
      setIsLoading(true);
      const token = getToken();
      if (token == "" || token == null) {
        navigate("/login");
      }
      const hostname =
        selectedServer && getServerRequestName(selectedServer)
          ? getServerRequestName(selectedServer)
          : selectedHostname;
      await downloadConfig(
        token,
        subscription.id,
        setIsLoading,
        hostname,
        subscription.login
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`${styles.container} ${styles["min-height"]} ${styles["without-label"]}`}
    >
      {hasLabel ? (
        <div className={`${styles.wrap} label mb-025`}>{label}</div>
      ) : (
        <></>
      )}
      {hasMultipleServers ? (
        <div className={`${styles["bg-all"]}`}>
          <Select className={styles.bg} onChange={setSelectedHostnameHandler}>
            {sortedServers.map((row) => {
              const hostname = getServerHostname(row);
              return (
                <option value={hostname} selected={hostname === selectedHostname}>
                  {formatServerLabel(row)}
                </option>
              );
            })}
          </Select>
        </div>
      ) : (
        <div className={`${styles.row} ${styles.wrap} label mb-05`}>
          {selectedServer && hasMultipleServers ? formatServerLabel(selectedServer) : ""}
        </div>
      )}
      <div className={styles.row}>
        <Button loading={isLoading} onClick={() => download()} mode="outline">
          {t("Download the OpenVPN config")}
        </Button>
      </div>
    </div>
  );
};

export default GuideOvpnData;
